// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Card_card__LRqWV {
  padding: 20px;
  background-color: var(--primary-color);
  border-radius: 10px;
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Card.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".card {\n  padding: 20px;\n  background-color: var(--primary-color);\n  border-radius: 10px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Card_card__LRqWV`
};
export default ___CSS_LOADER_EXPORT___;
